// extracted by mini-css-extract-plugin
module.exports = {"cancelSearch":"SearchInput_cancelSearch__-_852"};